"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellValue = void 0;
var styled_components_1 = require("styled-components");
exports.CellValue = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: #0074D9;\n    border: none;\n    background: none;\n    cursor: pointer;\n    text-decoration: underline;\n    font-size: 14px!important;\n\n    :hover {\n        color: #00539b;\n    }\n"], ["\n    color: #0074D9;\n    border: none;\n    background: none;\n    cursor: pointer;\n    text-decoration: underline;\n    font-size: 14px!important;\n\n    :hover {\n        color: #00539b;\n    }\n"])));
exports.CellValue.displayName = "CellValue";
var templateObject_1;
